import { Card, IconButton } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { ManagerAuthorization } from '@common/enums';
import { getSelectedLanguage } from '@frontend/translate';
import { hasOneAuthorization } from '@frontend/utils';
import { useServiceOrganizationSettingContext } from '@frontend/utils/hooks/useServiceOrganizationsSettingsContext';
import { ServiceOrganizationSettingFormMode } from '../../types';
import { ServiceOrganizationSettingZorgmailEdit } from './ServiceOrganizationSettingZorgmailEdit';
import { ServiceOrganizationSettingZorgmailRead } from './ServiceOrganizationSettingZorgmailRead';

export function ServiceOrganizationSettingZorgmail() {
    const { reloadServiceOrganizationSettings } = useServiceOrganizationSettingContext();
    const canEdit = hasOneAuthorization(ManagerAuthorization.organizationAddEdit);
    const [mode, setMode] = useState<ServiceOrganizationSettingFormMode>(ServiceOrganizationSettingFormMode.read);

    useEffect(() => {
        reloadServiceOrganizationSettings();
    }, []);

    return (
        <Card>
            <Card.Transition type={mode} />
            <Card.Header
                action={
                    mode === ServiceOrganizationSettingFormMode.read && canEdit ? (
                        <IconButton
                            icon="edit-light"
                            labelText="edit"
                            onClick={() => setMode(ServiceOrganizationSettingFormMode.edit)}
                        />
                    ) : null
                }
                title={getSelectedLanguage().serviceOrganizationSetting.zorgMail}
            />
            <Card.Body>
                {mode === ServiceOrganizationSettingFormMode.read ? (
                    <ServiceOrganizationSettingZorgmailRead />
                ) : (
                    <ServiceOrganizationSettingZorgmailEdit handleClose={handleClose} />
                )}
            </Card.Body>
        </Card>
    );

    async function handleClose(): Promise<void> {
        setMode(ServiceOrganizationSettingFormMode.read);
    }
}
